import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const serviceId = 4
const slug = 'civil-and-infrastructure-formwork-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Civil & Infrastructure Formwork Sydney | ${BUSINESS_NAME}`,
        description: "Bridges, roads, and large-scale civil formwork services. Expert infrastructure formwork solutions in Sydney.",
        keywords: "civil formwork sydney, infrastructure formwork, bridge formwork, road formwork, large-scale formwork, concrete formwork, structural support, commercial formwork, residential formwork, custom formwork design, construction project management, sydney builders",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Civil & Infrastructure Formwork Sydney',
    description: "Bridges, roads, and large-scale civil formwork services.",
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
